import { Component, OnInit, OnDestroy  } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalLoginComponent } from 'app/components/modals/modal-login/modal-login.component';
import { Utils } from 'app/components/utils/Utils';
import { Log } from 'app/core/logging/log';
import { ParameterCart } from 'app/models/cart-model';
import { InfoCart } from 'app/models/info-cart-model';
import { StockModel } from 'app/models/stock-model';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { AppService } from 'app/services/app/app.service';
import { EventsService } from 'app/services/events/events.service';
import { RestService } from 'app/services/rest/rest.service';
import { combineLatest, Observable, Subject, takeUntil } from 'rxjs';
import { UserData } from '../../../models/cart-model';
import { OrderPassword, TypePassword } from 'app/models/order-password-model';

@Component({
  selector: 'app-locker-checkout',
  templateUrl: './locker-checkout.page.html',
  styleUrls: ['./locker-checkout.page.scss'],
})
export class LockerCheckoutPage implements OnInit, OnDestroy {

  parameters: ParameterCart;
  reserved: string[] = [];
  startDate: string;
  endDate: string;
  type: number;
  nLocker: any;
  price: StockPromotionModel;
  mode: string;
  infoCart: InfoCart = {
    startDate: null, 
    endDate: null, 
    items: [],
    total: 0, 
    tax: 0,
    resumen: [],
    address: '',
    kioskAddress: ''
  };
  days: number = 0;
  discountValidated: boolean = false;
  
  //Formulario
  formData = { name: this.appService.usuario.username, email: this.appService.usuario.email, extension: '', telephoneNumber: '', 
                passwordLocker: '', provisionalPasswordLocker: '', checkoutPasswordLocker: '', 
                discountCode: '', insurance: false, agreement: false, langCode: AppService.langSel.name, price: '' };
  heroForm: FormGroup;
  private destroy$ = new Subject<void>()
  
  constructor(
    private restService: RestService,
    public appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    

    this.initForm();
    this.eventsService.publish('refreshStep', { title: "4/4", nameBt: null });
    this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);
    this.type = this.parameters.type;
    const startDateObj = new Date(this.parameters.startDate);
    const endDateObj = new Date(this.parameters.endDate);
    const diffTime = Math.abs(endDateObj.getTime() - startDateObj.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    this.days = diffDays;
    

    this.eventsService.subscribe('checkoutMethod', result => {
      if(result == 'checkoutCardStripe'){
        this.checkoutCardStripe();
      } else if(result == 'checkoutCardPaypal'){
        this.checkoutCardPaypal();
      } else if(result == 'checkoutFree'){
        this.checkoutCardStripe();
      }
      
    });

    /*
    this.eventsService.subscribe('callBack', result => {
      console.log('LockerCheckoutPage callBack', result);
      this.parameters.userData = this.heroForm.value;
      this.router.navigate(['/reserve/checkout'], { queryParams: Utils.generateParams(this.parameters) });
    });*/

    if(this.parameters.userData){
      if(this.parameters.userData.name) this.name.setValue(this.parameters.userData.name);
      if(this.parameters.userData.email) this.email.setValue(this.parameters.userData.email);
      if(this.parameters.userData.extension) this.extension.setValue(this.parameters.userData.extension);
      if(this.parameters.userData.telephoneNumber) this.telephoneNumber.setValue(this.parameters.userData.telephoneNumber);
      //if(this.parameters.userData.passwordLocker) this.passwordLocker.setValue(this.parameters.userData.passwordLocker);
      if(this.parameters.userData.discountCode) this.discountCode.setValue(this.parameters.userData.discountCode);
      if(this.parameters.userData.insurance) this.insurance.setValue(this.parameters.userData.insurance);
      //if(this.parameters.userData.agreement) this.agreement.setValue(this.parameters.userData.agreement);
    }

    this.eventsService.subscribe('getProfile', result => {
      this.name.setValue(this.appService.usuario.username);
      this.email.setValue(this.appService.usuario.email);
    });

    if(this.discountCode.value){
      this.validateDiscount();
    }else{
      this.showCart();
    }

   /* setInterval(()=>{
      console.log('interaval')
      this.parameters.userData = this.heroForm.value;
      this.router.navigate(['/reserve/checkout'], { queryParams: Utils.generateParams(this.parameters) });
    }, 2000);*/
    
    //console.log('parameters', this.parameters)
  }

  ngOnDestroy() {
    this.eventsService.destroy('checkoutCardStripe');
    this.eventsService.destroy('checkoutCardPaypal');
    this.eventsService.destroy('getProfile');
    this.eventsService.destroy('checkoutMethod');
    this.destroy$.next();
    this.destroy$.complete();
  }

  
  get f() { return this.heroForm.controls; }
  get name() { return this.heroForm.get('name'); }
  get email() { return this.heroForm.get('email'); }
  get extension() { return this.heroForm.get('extension'); }
  get telephoneNumber() { return this.heroForm.get('telephoneNumber'); }
  get passwordLocker() { return this.heroForm.get('passwordLocker'); }
  get provisionalPasswordLocker() { return this.heroForm.get('provisionalPasswordLocker'); }
  get checkoutPasswordLocker() { return this.heroForm.get('checkoutPasswordLocker'); }
  get discountCode() { return this.heroForm.get('discountCode'); }
  get insurance() { return this.heroForm.get('insurance'); }
  get agreement() { return this.heroForm.get('agreement'); }


  initForm(){
    this.heroForm = new FormGroup({
      'name': new FormControl(this.formData.name, [
        Validators.required,
        Validators.minLength(4)
      ]),
      'email': new FormControl(this.formData.email, [
        Validators.required,
        Validators.minLength(4),
        Validators.email
      ]),
      'extension': new FormControl(this.formData.extension, [
        Validators.required,
        Validators.pattern("^\\+[0-9]+$")
      ]),
      'telephoneNumber': new FormControl(this.formData.telephoneNumber, [
        Validators.required,
        Validators.minLength(9),
        Validators.pattern("^[0-9]*$")
      ]),
     /* 'passwordLocker': new FormControl(this.formData.passwordLocker, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern("^[0-9]*$")
      ]),*/
      'provisionalPasswordLocker': new FormControl(this.formData.provisionalPasswordLocker, [
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern("^[0-9]*$")
      ]),
      'checkoutPasswordLocker': new FormControl(this.formData.checkoutPasswordLocker, [
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern("^[0-9]*$")
      ]),
      'discountCode': new FormControl(this.formData.discountCode, [
        Validators.minLength(4)
      ]),
      //'insurance': new FormControl(this.formData.insurance, {
      //  updateOn: 'blur'
      //}),
      'agreement': new FormControl(this.formData.agreement, [
        Validators.requiredTrue
      ]),
      'langCode': new FormControl(this.formData.langCode, [
        Validators.required
      ])
    },
    {   
      validators: this.discountValidator.bind(this)
    });
    
  }

  onChangePrice(ev: any, p: any){
    this.parameters.items[0].priceId = p.id;
    this.parameters.items[0].priceType = p.type;
    this.eventsService.publish('showPaymentPaypalBt', p.type != 'RECURRENT');
    this.discountValidated = false;
    this.discountCode.setValue('');
    this.showCart();
  }

  isRenovation(){
    return this.parameters.orderUuid != null;
  }

  get isModeKey(): boolean{
    return this.mode == 'KEY';
  }

  discountValidator(formGroup: FormGroup) {
    const { value: discountCode } = formGroup.get('discountCode');
    return discountCode != '' && !this.discountValidated ? {discountValidated:true} : null;
  }

  persitUserData(){
    this.parameters.userData = this.heroForm.value;
    this.router.navigate(['/reserve', this.appService.kiosk, 'checkout'], { queryParams: Utils.generateParams(this.parameters) })
  }
  
  persitCommissionAgentId(commissionAgentId: number){
    //if((this.parameters.commissionAgentId == null  && commissionAgentId != null) || (this.parameters.commissionAgentId != null && commissionAgentId == null)){
      this.parameters.commissionAgentId = commissionAgentId;
      this.router.navigate([], {
          relativeTo: this.route,
          queryParams: Utils.generateParams(this.parameters),
          //queryParamsHandling: 'merge'
      });
    //}
  }

  showCart(){

    const cartRequest = Utils.cartRequest(this.parameters, this.heroForm.value);
    Log.debug('showCart cartRequest', {parameters: this.parameters});
     combineLatest(
          {
            stock: this.appService.currentStock$,
            //price: this.appService.currentPrice$,
            infoCart: this.restService.infoCart(cartRequest)
          } as {stock: Observable<StockModel>, price: Observable<StockPromotionModel>, infoCart: Observable<InfoCart>}
        ).pipe(takeUntil(this.destroy$))
        .subscribe(({ stock, price, infoCart }) => {
          Log.debug('subscribe stock', {stock});
          Log.debug('subscribe price', {price});
          Log.debug('subscribe infoCart', {infoCart});

          this.price = price;
          this.infoCart = infoCart;
          this.mode = Utils.getMode(stock, this.parameters);
      
          if(this.infoCart.userData.discountCode != null && this.infoCart.userData.discountCode != ""){
            this.discountCode.setValue(this.infoCart.userData.discountCode);
            this.discountValidated = true;
            this.persitUserData();
            this.discountCode.clearValidators();
          }
          
          //if(this.infoCart.total == 0){
          //  this.eventsService.publish('showPaymentFreeBt', true);
          //}
          
          this.eventsService.publish('showPaymentFreeBt', this.infoCart.total == 0);

          const isRecurrent: boolean = this.infoCart.resumen.some(it => it.priceType === "RECURRENT");
          this.eventsService.publish('showPaymentPaypalBt', !isRecurrent)


        });

    

  }

  msgError(error:any){
    if(error.code == 502){
      this.appService.showDangerToast(error.description);
      this.router.navigate(['landing']);
    }
  }

  validateDiscount(){
    const cartRequest = Utils.cartRequest(this.parameters, this.heroForm.value);
    this.restService.validateDiscount(cartRequest).subscribe((result:{success: boolean, commissionAgentId: number|null}) => {

      if(result.success){
        this.discountValidated = true;
        this.persitUserData();
        if(result.commissionAgentId){
          this.persitCommissionAgentId(result.commissionAgentId);
        }
      }else{
        this.discountValidated = false;
        this.discountCode.setValue('');
        this.appService.showDangerToast('Descuento no aplicado');
      }
      this.showCart();
    });
  }

  deleteDiscount(){
    this.discountCode.setValue('');
    this.discountValidated = false;
    this.persitUserData();
    this.persitCommissionAgentId(null);
    this.showCart();
  }
  
  get getUserData():UserData{
    const pass:OrderPassword = {
      provisionalPassword: this.heroForm.get('provisionalPasswordLocker')?.value,
      checkoutPassword: this.heroForm.get('checkoutPasswordLocker')?.value,
      typePassword: TypePassword.LOCKER
    };

    return {
      id: null,
      name: this.heroForm.get('name')?.value,
      email: this.heroForm.get('email')?.value,
      passwordLocker: pass,
      discountCode: this.heroForm.get('discountCode')?.value,
      extension: this.heroForm.get('extension')?.value,
      telephoneNumber: this.heroForm.get('telephoneNumber')?.value,
      agreement: this.heroForm.get('agreement')?.value,
      insurance: this.heroForm.get('insurance')?.value,
      langCode: AppService.langSel.name,
    };
  }

  checkoutCardStripe(){
    this.validateAllFormFields(this.heroForm);
    if (this.heroForm.invalid) {
      Log.error("No validado Stripe", {form: this.heroForm});
      return;
    }

    this.setCustomPassword();
    this.persitUserData();
    const cartRequest = Utils.cartRequest(this.parameters, this.getUserData);
    this.restService.checkoutCardStripe(cartRequest).subscribe((result:any) => {
      window.location.href = result.url;
    },err=>{
      this.msgError(err.error);
    });
  }

  checkoutCardMypost(){
    this.validateAllFormFields(this.heroForm);
    if (this.heroForm.invalid) {
      Log.error("No validado Mypos", {form: this.heroForm});
      return;
    }

    this.setCustomPassword();
    this.persitUserData();
    const cartRequest = Utils.cartRequest(this.parameters, this.getUserData);
    this.restService.checkoutCardMypost(cartRequest).subscribe((result:any) => { 
      window.location.href = result.url;
    },err=>{
      this.msgError(err.error);
    });
  }

  checkoutCardPaypal(){
    this.validateAllFormFields(this.heroForm);
    if (this.heroForm.invalid) {
      Log.error("No validado Paypal", {form: this.heroForm});
      return;
    }

    this.setCustomPassword();
    this.persitUserData();
    const cartRequest = Utils.cartRequest(this.parameters, this.getUserData);
    this.restService.checkoutCardPaypal(cartRequest).subscribe((result:any) => { 
      window.location.href = result.url;
    },err=>{
      this.msgError(err.error);
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });

        // Buscar el primer elemento inválido
        const firstInvalidControl: HTMLElement = document.querySelector(
          'form .ng-invalid'
        ) as HTMLElement;

        if (firstInvalidControl) {
          firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalidControl.focus();
        }

      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  
  transformExtension(){
    if(this.extension.value.charAt(0) != '+'){
      this.extension.setValue("+"+this.extension.value)
    }
    
  }

  setCustomPassword(){
    let pass = {
      provisionalPassword: String(this.heroForm.value.provisionalPasswordLocker),
      checkoutPassword: String(this.heroForm.value.checkoutPasswordLocker)
    }
    this.heroForm.value.passwordLocker = JSON.stringify(pass);
  }

  login(){
    let options: NgbModalOptions = {
      scrollable: true,
    //  size: 'xl',
      centered: true
    };
    const modalRef = this.modalService.open(ModalLoginComponent, options);
    modalRef.result.then((data) => {
      Log.debug("data", {data: data});
      window.location.reload();
      //this.confirm(data);
    }, (reason) => {
      // on dismiss
      Log.debug("reason", {reason: reason});
    });
  }

  logout(){
    if(!confirm(this.appService.getTraduccion('logout.areyousure'))) {
      return;
    }
    AppService.clearToken();
  }

  formatPin(value: any){
    let start = 0;
    let id = this.appService.usuario.id;
    let filled = value.padEnd(4, '*');
    return start +''+ id +''+ filled;
  }


}
